export const CONTACT_EMAIL = "Chirpwell1@gmail.com";
export const SITE_NAVIGATION = [
  { label: "Home", href: "/" },
  { label: "Solutions", href: "/#solutions" },
  { label: "Free Tools", href: "/#tools" },
  { label: "About", href: "/#about" },
  { label: "Contact", href: "/#contact" },
];